import { ImageDestinationEnum, ImageSizesEnum } from '../enums';

export class ImageCompressingOptions {
	public maxWidth: number | null;
	public maxHeight: number | null;
	public variants?: Pick<
		Record<ImageSizesEnum, Omit<ImageCompressingOptions, 'variants'>>,
		ImageSizesEnum.M | ImageSizesEnum.S | ImageSizesEnum.XS
	>;
}

export const ImageDestinationSizes: Record<ImageDestinationEnum, ImageSizesEnum[]> = {
	[ImageDestinationEnum.Users]: [ImageSizesEnum.XS, ImageSizesEnum.S],
	[ImageDestinationEnum.Chats]: [ImageSizesEnum.S, ImageSizesEnum.M],
	[ImageDestinationEnum.FeaturedImages]: [ImageSizesEnum.M, ImageSizesEnum.L],
	[ImageDestinationEnum.Events]: [
		ImageSizesEnum.S,
		ImageSizesEnum.M,
		ImageSizesEnum.L,
		ImageSizesEnum.XL,
	],
	[ImageDestinationEnum.Lobby]: [ImageSizesEnum.S, ImageSizesEnum.M, ImageSizesEnum.L],
	[ImageDestinationEnum.Newsfeed]: [ImageSizesEnum.M, ImageSizesEnum.L],
};
